import { render, staticRenderFns } from "./MemberLevelSettingStep2Deposit.vue?vue&type=template&id=2cf5ba6e&"
import script from "./MemberLevelSettingStep2Deposit.vue?vue&type=script&lang=js&"
export * from "./MemberLevelSettingStep2Deposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports